export const style = {
    wrapper: {
        position: 'fixed',
        left: '8px',
        right: '8px',
        maxWidth: '630px',
        margin: '0 auto',
        zIndex: 1
    },
    alert: {
        filter: 'drop-shadow(0px 0px 2px rgba(45, 45, 45, 0.2)) drop-shadow(0px 4px 8px rgba(45, 45, 45, 0.16)) drop-shadow(0px 8px 16px rgba(45, 45, 45, 0.12))'
    }
};
